import React, {useState} from "react";
import Icon from "../icon";
import RichTextEditor from "./rich-text-editor";
import RichTextView from "./rich-text-view";
import "./rich-text.css";

// A description shown in place (a sidebar, an identity page) and edited in place: click it (or «ویرایش») to open the
// editor, then «ذخیره» or «انصراف». Enter makes a new paragraph, so saving is an explicit button. While editable it is
// drawn as a box with a «برای نوشتن کلیک کنید» hint, so it reads as a text field.
// `onSave(html)` may return a promise; while it runs the buttons wait.
function RichTextField({value, onSave, placeholder = "---", disabled = false, emptyText = "---", minHeight = "7rem", className = ""}) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("");
    const [saving, setSaving] = useState(false);

    const start = () => {
        if (disabled) return;
        setDraft(value || "");
        setEditing(true);
    };
    const save = async () => {
        setSaving(true);
        try {
            await onSave?.(draft);
            setEditing(false);
        } finally {
            setSaving(false);
        }
    };

    if (!editing) {
        return (
            <div
                className={`zr-field ${disabled ? "" : "is-editable"} ${className}`}
                role={disabled ? undefined : "button"}
                tabIndex={disabled ? undefined : 0}
                title={disabled ? undefined : "برای ویرایش کلیک کنید"}
                onClick={start}
                onKeyDown={(event) => {
                    if (!disabled && event.key === "Enter") {
                        event.preventDefault();
                        start();
                    }
                }}
            >
                <RichTextView value={value} empty={disabled
                    ? <span className="zr-empty">{emptyText}</span>
                    : <span className="zr-placeholder"><Icon icon="mi mi:edit_note" className="text-base"/>{placeholder && placeholder !== "---" ? placeholder : "برای نوشتن کلیک کنید…"}</span>}/>
                {!disabled && value && <span className="zr-field-hint" aria-hidden="true"><Icon icon="mi mi:edit" className="text-xs"/>ویرایش</span>}
            </div>
        );
    }

    return (
        <div className={`zr-field is-editing ${className}`}>
            <RichTextEditor value={draft} onChange={setDraft} placeholder={placeholder} minHeight={minHeight} autoFocus/>
            <div className="zr-field-actions">
                <button type="button" className="zr-btn zr-btn-primary" disabled={saving} onClick={save}>{saving ? "در حال ذخیره…" : "ذخیره"}</button>
                <button type="button" className="zr-btn" disabled={saving} onClick={() => setEditing(false)}>انصراف</button>
            </div>
        </div>
    );
}

export default RichTextField;
